import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {TaskRecord, TaskRecordService} from "../../../../../lib/task/task-record.service";
import {MultiselectOptionItem, UiConstants} from "../../../../../util/core-utils";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {Set} from "immutable";
import {TaskRecordResource} from "../../../../../lib/task/task-record-resource.service";
import {Models} from "../../../../../util/model-utils";
import {FormFieldOptionItem} from "../../../../../util/form/form-utils";
import {DownloadedFile} from "../../../../../lib/util/downloaded-files";
import {saveAs} from 'file-saver';
import {FormBuilder, FormGroup, NgForm, Validators} from "@angular/forms";
import {ForwardingNgFormRef, LocalFormGroupValidationErrors} from "../../../../../lib/util/services";
import {AppValidators} from "../../../../../util/app-validators";
import {Angular2Multiselects} from "../../../../../util/multiselect";
import {TaskService} from "../../../../../lib/task/task.service";
import {Form} from "../../../../../lib/form/form.service";
import FieldDataTypeSelector = Form.FieldDataTypeSelector;
import TaskRecordAttachmentType = TaskRecordResource.TaskRecordAttachmentType;

@Component({
  selector: 'app-task-record-state-change-dialog',
  templateUrl: './task-record-download-all-files-dialog.component.html',
  styleUrls: ['./task-record-download-all-files-dialog.component.scss']
})
export class TaskRecordDownloadAllFilesDialogComponent implements OnInit {

  UiConstants = UiConstants;
  TaskRecord = TaskRecord;

  model: TaskRecordDownloadAllFilesModel = new TaskRecordDownloadAllFilesModel();
  loading: boolean = false;

  @ViewChild('f', {static: true})
  form: NgForm;
  formGroup: FormGroup;
  private formGroupValidationErrors: LocalFormGroupValidationErrors;
  fileTypeDropdownSettings?: Angular2Multiselects.Settings;
  formFieldDropdownSettings?: Angular2Multiselects.Settings;
  fileTypes: MultiselectOptionItem<TaskRecordResource.TaskRecordAttachmentType>[] = [];
  formFields: FormFieldOptionItem[] = [];


  constructor(private taskRecordService: TaskRecordService,
              private fb: FormBuilder,
              private taskService: TaskService,
              public dialogRef: MatDialogRef<TaskRecordDownloadAllFilesDialogComponent, TaskRecordDownloadAllFilesDialogResult>,
              @Inject(MAT_DIALOG_DATA) public data: TaskRecordDownloadAllFilesDialogData) {
    this.formGroup = this.createFormGroup(this.fb);
    this.formGroupValidationErrors = LocalFormGroupValidationErrors.ofForm(
      this.createForwardingHtmlForm(),
      this.formGroup
    );
  }

  ngOnInit(): void {
    this.initDropdownSettings();
    this.initDropdownLists();
  }

  private initDropdownSettings() {
    this.fileTypeDropdownSettings = new Angular2Multiselects.SettingsBuilder()
      .singleSelection(false)
      .enableSearchFilter(true)
      .enableCheckAll(true)
      .remoteSearch(false)
      .translate(true)
      .build();

    this.formFieldDropdownSettings = new Angular2Multiselects.SettingsBuilder()
      .singleSelection(false)
      .enableSearchFilter(true)
      .enableCheckAll(true)
      .remoteSearch(false)
      .translate(false)
      .build();

  }

  private initDropdownLists() {
    this.fileTypes = TaskRecord.taskRecordFileTypes.map(f => {
      return {id: f.id, itemName: f.stringKey}
    });
    this.model.fileTypes = [];
    this.model.fileTypes.push(...this.fileTypes);

    this.taskService.getForm({parentId: this.data.taskId}).subscribe(form => {
      const fields: Form.Field[] = [];
      this.formFields = [];
      form.groups.toArray().filter(g=> !g.disabled).forEach(g => fields.push(...g!.fields.toArray()));
      fields.filter(f => !f.disabled && (f.dataTypeSelector === FieldDataTypeSelector.PHOTO || f.dataTypeSelector === FieldDataTypeSelector.DOCUMENT))
        .forEach(f => {
        const ff = new FormFieldOptionItem();
        ff.id = f.fieldId;
        ff.dataTypeSelector = f.dataTypeSelector;
        ff.itemName = f.title;
        ff.itemSubtitle = f.apiExportName;
        this.formFields.push(ff);
        this.model.formFields.push(ff);
      });
      if (this.formFields.length === 0) {
        this.model.fileTypes = this.model.fileTypes.filter(t => t.id !== TaskRecordAttachmentType.FORM_FIELD);
        this.fileTypes = this.fileTypes.filter(t => t.id !== TaskRecordAttachmentType.FORM_FIELD);
      }
    });

  }

  public static openDialog(
    dialog: MatDialog,
    data: TaskRecordDownloadAllFilesDialogData,
    resultCallback: (result?: TaskRecordDownloadAllFilesDialogResult) => void): MatDialogRef<TaskRecordDownloadAllFilesDialogComponent> {
    const dialogRef = dialog.open(TaskRecordDownloadAllFilesDialogComponent, {
      closeOnNavigation: true,
      data: data,
      width: '60%',
      height: 'auto',
      panelClass: 'custom-dialog-container'
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      resultCallback({success: result});
    });
    return dialogRef;
  }

  private createForwardingHtmlForm() {
    return new ForwardingNgFormRef({
      formFn: () => {
        return this.form;
      }
    });
  }

  private createFormGroup(fb: FormBuilder): FormGroup {
    return fb.group(
      {
        fileTypes: fb.control(
          {value: this.model.fileTypes},
          [Validators.required]
        ),
        formFields: fb.control(
          {value: this.model.formFields},
          [AppValidators.tempValidator({validator: Validators.required, disabled: () => {
              return !this.model.formFieldsEnabled || this.formFields.length === 0
            }})]
        ),
      }
    );
  }

  hasLocalFieldError(formControlName?: string, errorCode?: string): boolean {
    return this.formGroupValidationErrors.hasFieldError(formControlName, errorCode);
  }



  tryDownloadFiles() {
    if (this.hasLocalFieldError()) {
      return;
    }
    if (!this.loading && this.model && this.data.ids.size > 0) {
      this.loading = true;
      this.taskRecordService.downloadAllFilesForList({
        taskId: this.data.taskId,
        taskRecordIds: this.data.ids,
        fileTypes: this.model.fileTypeSet,
        formFieldIds: this.model.formFieldIdSet,
      }).subscribe((res: DownloadedFile) => {
          this.loading = false;
          saveAs(res.getBlob(), res.getFileName(`${this.data.taskId}-all-files.zip`));
          this.close(true);
        });
    }
  }

  close(success: boolean) {
    this.dialogRef.close({success: success});
  }

  fileTypeSelected(event: MultiselectOptionItem<TaskRecordResource.TaskRecordAttachmentType>[]) {
    if (event.filter(e => e.id === TaskRecordAttachmentType.FORM_FIELD)) {
      this.model.formFields = this.formFields;
    }
  }

  fileTypeDeSelected(event: MultiselectOptionItem<TaskRecordResource.TaskRecordAttachmentType>[]) {
    if (event.filter(e => e.id === TaskRecordAttachmentType.FORM_FIELD)) {
      this.model.formFields = [];
    }
  }
}

export class TaskRecordDownloadAllFilesDialogData {
  ids: Set<number>;
  taskId: number;
}

export class TaskRecordDownloadAllFilesDialogResult {
  success: boolean;
}

class TaskRecordDownloadAllFilesModel {
  formFields: FormFieldOptionItem[] = [];
  fileTypes: MultiselectOptionItem<TaskRecordResource.TaskRecordAttachmentType>[] = [];

  get formFieldsEnabled(): boolean {
    if (this.fileTypes.length === 0) {
      return false;
    }
    return this.fileTypes.findIndex(f => f.id === TaskRecordAttachmentType.FORM_FIELD) >= 0;
  }

  get fileTypeSet(): Set<TaskRecordResource.TaskRecordAttachmentType> | undefined {
    return Models.toIdSet(this.fileTypes);
  }

  get formFieldIdSet(): Set<number> | undefined {
    return Models.toIdSet(this.formFields);
  }
}
